<template>
	<div class="">
		<!-- 登录信息 -->
		<global-tips></global-tips>
		<!-- 系统设置 -->
		  <el-tabs type="border-card" v-model="tabIndex" @tab-click="handleClick">
		    <el-tab-pane label="基础设置">
		      <el-form label-width="150px" label-position="left">
		          <el-form-item label="系统名称" prop="shop_name">
		             <el-input :value="shop_name" @input="vModel('shop_name',$event)" placeholder="请输入系统名称" size="small"></el-input>
		          </el-form-item>
				  <el-form-item label="系统全名" prop="full_name">
				     <el-input :value="full_name" @input="vModel('full_name',$event)" placeholder="请输入系统全名" size="small"></el-input>
				  </el-form-item>
		          <el-form-item label="备案信息" prop="shop_beian">
		             <el-input :value="shop_beian" @input="vModel('shop_beian',$event)" placeholder="请输入备案信息" size="small"></el-input>
		          </el-form-item>
				  <el-form-item label="系统描述" prop="shop_desc">
				     <el-input :value="shop_desc" @input="vModel('shop_desc',$event)" placeholder="请输入系统描述" size="small" type="textarea" :rows="3"></el-input>
				  </el-form-item>
				  <el-form-item>
					<el-button type="primary" size="small" @click="submit">确定</el-button>
				  </el-form-item>
		      </el-form>
		    </el-tab-pane>
			<el-tab-pane label="其他设置">
			  <el-form label-width="150px" label-position="left">
			      <el-form-item label="协会地址" prop="xh_address">
			         <el-input :value="xh_address" @input="vModel('xh_address',$event)" placeholder="请输入协会地址" size="small"></el-input>
			      </el-form-item>
				  <el-form-item label="咨询热线" prop="zxrx">
				     <el-input :value="zxrx" @input="vModel('zxrx',$event)" placeholder="请输入咨询热线" size="small"></el-input>
				  </el-form-item>
			      <el-form-item label="综合部电话" prop="zhb_phone">
			         <el-input :value="zhb_phone" @input="vModel('zhb_phone',$event)" placeholder="请输入综合部电话" size="small"></el-input>
			      </el-form-item>
				  <el-form-item label="会员部电话" prop="hyb_phone">
				     <el-input :value="hyb_phone" @input="vModel('hyb_phone',$event)" placeholder="请输入会员部电话" size="small"></el-input>
				  </el-form-item>
				  <el-form-item label="行政部电话" prop="xzb_phone">
				     <el-input :value="xzb_phone" @input="vModel('xzb_phone',$event)" placeholder="请输入行政部电话" size="small"></el-input>
				  </el-form-item>
				  <el-form-item label="培训中心电话" prop="pxzx_phone">
				     <el-input :value="pxzx_phone" @input="vModel('pxzx_phone',$event)" placeholder="请输入培训中心电话" size="small"></el-input>
				  </el-form-item>
				  <el-form-item label="协会传真" prop="xh_fax">
				     <el-input :value="xh_fax" @input="vModel('xh_fax',$event)" placeholder="请输入协会传真" size="small"></el-input>
				  </el-form-item>
				  <el-form-item label="协会邮箱" prop="xh_email">
				     <el-input :value="xh_email" @input="vModel('xh_email',$event)" placeholder="请输入协会邮箱" size="small"></el-input>
				  </el-form-item>
				  <el-form-item>
					<el-button type="primary" size="small" @click="submit">确定</el-button>
				  </el-form-item>
			  </el-form>
			</el-tab-pane>
			<el-tab-pane label="协会证书">
			  <el-form label-width="150px" label-position="left">
				  <el-form-item label="证书名称" prop="certificate_name">
				     <el-input :value="certificate_name" @input="vModel('certificate_name',$event)" placeholder="请输入证书名称" size="small"></el-input>
				  </el-form-item>
				  <el-form-item label="发证单位" prop="issuing_authority">
				     <el-input :value="issuing_authority" @input="vModel('issuing_authority',$event)" placeholder="请输入发证单位" size="small"></el-input>
				  </el-form-item>
				  <el-form-item label="公众号" prop="gzh_img">
					<el-upload
					  class="upload-border"
					  action="/manage/images/upload"
					  :headers="uploadHeaders"
					  :show-file-list="false"
					  :on-success="(res) => gzhUploadSuccess(res)"
					  :before-upload="beforeUpload"
					  accept="image/*">
					  <div class="flex align-center flex-wrap overflow-hidden" style="height: 100px; width: 100px;" v-if="gzh_img">
						<img :src="gzh_img" style="max-width: 100%; max-height: 100%; object-fit: contain;" />
					  </div>
					  <i class="el-icon-plus text-muted" style="font-size: 30px;" v-else></i>
					</el-upload>
					<small class="d-block text-secondary mt-1" style="line-height: 20px;">请上传公众号二维码图片</small>
				  </el-form-item>
				  <el-form-item label="公章" prop="gz_img">
					<el-upload
					  class="upload-border"
					  action="/manage/images/upload"
					  :headers="uploadHeaders"
					  :show-file-list="false"
					  :on-success="(res) => gzUploadSuccess(res)"
					  :before-upload="beforeUpload"
					  accept="image/*">
					  <div class="flex align-center flex-wrap overflow-hidden" style="height: 100px; width: 100px;" v-if="gz_img">
						<img :src="gz_img" style="max-width: 100%; max-height: 100%; object-fit: contain;" />
					  </div>
					  <i class="el-icon-plus text-muted" style="font-size: 30px;" v-else></i>
					</el-upload>
					<small class="d-block text-secondary mt-1" style="line-height: 20px;">请上传公章图片</small>
				  </el-form-item>
				  <el-form-item label="证书Logo" prop="certificate_logo">
					<el-upload
					  class="upload-border"
					  action="/manage/images/upload"
					  :headers="uploadHeaders"
					  :show-file-list="false"
					  :on-success="(res) => certificateLogoUploadSuccess(res)"
					  :before-upload="beforeUpload"
					  accept="image/*">
					  <div class="flex align-center flex-wrap overflow-hidden" style="height: 100px; width: 100px;" v-if="certificate_logo">
						<img :src="certificate_logo" style="max-width: 100%; max-height: 100%; object-fit: contain;" />
					  </div>
					  <i class="el-icon-plus text-muted" style="font-size: 30px;" v-else></i>
					</el-upload>
					<small class="d-block text-secondary mt-1" style="line-height: 20px;">请上传证书Logo图片</small>
				  </el-form-item>
				  <el-form-item label="证书背景" prop="certificate_bg">
					<el-upload
					  class="upload-border"
					  action="/manage/images/upload"
					  :headers="uploadHeaders"
					  :show-file-list="false"
					  :on-success="(res) => certificateBgUploadSuccess(res)"
					  :before-upload="beforeUpload"
					  accept="image/*">
					  <div class="flex align-center flex-wrap overflow-hidden" style="height: 100px; width: 100px;" v-if="certificate_bg">
						<img :src="certificate_bg" style="max-width: 100%; max-height: 100%; object-fit: contain;" />
					  </div>
					  <i class="el-icon-plus text-muted" style="font-size: 30px;" v-else></i>
					</el-upload>
					<small class="d-block text-secondary mt-1" style="line-height: 20px;">请上传证书背景图片</small>
				  </el-form-item>
				  <el-form-item label="注意事项" prop="official_seal">
				     <el-input :value="official_seal" @input="vModel('official_seal',$event)" placeholder="请输入注意事项" size="small" type="textarea" :rows="5"></el-input>
				  </el-form-item>
				  <el-form-item>
					<el-button type="primary" size="small" @click="submit">确定</el-button>
				  </el-form-item>
			  </el-form>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import { mapState,mapMutations,mapGetters } from "vuex"
	import GlobalTips from "@/components/GlobalTips";
	export default {
		inject:['app'],
		components: {
			GlobalTips,
		},
		computed:{
			...mapState({
			  shop_name:state=>state.setting.shop_name,
			  company_name:state=>state.setting.company_name,
			  shop_address:state=>state.setting.shop_address,
			  shop_desc:state=>state.setting.shop_desc,
			  shop_beian:state=>state.setting.shop_beian,
			  kf_mobile:state=>state.setting.kf_mobile,
			  search_keywords:state=>state.setting.search_keywords,
			  shop_logo:state=>state.setting.shop_logo,
			  full_name:state=>state.setting.full_name,
			  xh_address:state=>state.setting.xh_address,
			  zxrx:state=>state.setting.zxrx,
			  zhb_phone:state=>state.setting.zhb_phone,
			  hyb_phone:state=>state.setting.hyb_phone,
			  xzb_phone:state=>state.setting.xzb_phone,
			  pxzx_phone:state=>state.setting.pxzx_phone,
			  xh_fax:state=>state.setting.xh_fax,
			  xh_email:state=>state.setting.xh_email,
			  //协会证书
			  gzh_img:state=>state.setting.gzh_img,
			  gz_img:state=>state.setting.gz_img,
			  certificate_name:state=>state.setting.certificate_name,
			  issuing_authority:state=>state.setting.issuing_authority,
			  certificate_logo:state=>state.setting.certificate_logo,
			  certificate_bg:state=>state.setting.certificate_bg,
			  official_seal:state=>state.setting.official_seal,
			}),
			...mapGetters([
			  'getData',
			]),
			// 上传headers，包含token
			uploadHeaders() {
			  const token = this.$cookies.get('token') || '';
			  return {
				'token': token
			  };
			},
		},
		data() {
			return {
				tabIndex:0,
			}
		},
		mounted(){
		  this.getList()
		},
		methods:{
			...mapMutations(['editState','editParamsState']),
			vModel(key,val){
			  this.editState({key,val})
			},
			vModelParams(name,key,val){
			  this.editParamsState({name,key,val})
			},
			handleClick(tab, event) {
			 // console.log(tab, event);
			},
			getList(){
			  this.axios.get('/manage/setting/index').then(res=>{
				if(res.status){
				  if(res.data.length > 0){
					  this.$store.commit('initSetting',res.data)
				  }
				}
			  })
			},
			submit(){
			  this.axios.post('/manage/setting/save',this.getData).then(res=>{
				if(res.status){
				  this.$message.success(res.msg)
				}else{
				  this.$message.error(res.msg)
				}
			  })
			},
			// 图片上传前的校验
			beforeUpload(file) {
			  const isImage = file.type.indexOf('image/') === 0;
			  const isLt2M = file.size / 1024 / 1024 < 2;
			  
			  if (!isImage) {
				this.$message.error('只能上传图片文件！');
				return false;
			  }
			  if (!isLt2M) {
				this.$message.error('上传图片大小不能超过 2MB!');
				return false;
			  }
			  return true;
			},
			// 公众号图片上传成功回调
			gzhUploadSuccess(res) {
			  if (res.status) {
				this.vModel('gzh_img', res.data.url);
				this.$message.success('上传成功');
			  } else {
				this.$message.error(res.msg || '上传失败');
			  }
			},
			// 公章图片上传成功回调
			gzUploadSuccess(res) {
			  if (res.status) {
				this.vModel('gz_img', res.data.url);
				this.$message.success('上传成功');
			  } else {
				this.$message.error(res.msg || '上传失败');
			  }
			},
			// 证书Logo图片上传成功回调
			certificateLogoUploadSuccess(res) {
			  if (res.status) {
				this.vModel('certificate_logo', res.data.url);
				this.$message.success('上传成功');
			  } else {
				this.$message.error(res.msg || '上传失败');
			  }
			},
			// 证书背景图片上传成功回调
			certificateBgUploadSuccess(res) {
			  if (res.status) {
				this.vModel('certificate_bg', res.data.url);
				this.$message.success('上传成功');
			  } else {
				this.$message.error(res.msg || '上传失败');
			  }
			},
		}
	}
</script>

<style scoped>
.upload-border {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-border:hover {
  border-color: #409eff;
}

.upload-border .el-upload {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>